import classNames from 'classnames';

var getPaddingClassNames = function getPaddingClassNames(map) {
  var top = map.top,
      right = map.right,
      bottom = map.bottom,
      left = map.left,
      horizontal = map.horizontal,
      vertical = map.vertical,
      all = map.all;
  return classNames({
    'Padding-top--0': top === 0,
    'Padding-top--2': top === 2,
    'Padding-top--4': top === 4,
    'Padding-top--8': top === 8,
    'Padding-top--12': top === 12,
    'Padding-top--16': top === 16,
    'Padding-top--20': top === 20,
    'Padding-top--24': top === 24,
    'Padding-top--32': top === 32,
    'Padding-top--48': top === 48,
    'Padding-top--64': top === 64,
    'Padding-top--80': top === 80,
    'Padding-right--0': right === 0,
    'Padding-right--2': right === 2,
    'Padding-right--4': right === 4,
    'Padding-right--8': right === 8,
    'Padding-right--12': right === 12,
    'Padding-right--16': right === 16,
    'Padding-right--20': right === 20,
    'Padding-right--24': right === 24,
    'Padding-right--32': right === 32,
    'Padding-right--48': right === 48,
    'Padding-right--64': right === 64,
    'Padding-right--80': right === 80,
    'Padding-bottom--0': bottom === 0,
    'Padding-bottom--2': bottom === 2,
    'Padding-bottom--4': bottom === 4,
    'Padding-bottom--8': bottom === 8,
    'Padding-bottom--12': bottom === 12,
    'Padding-bottom--16': bottom === 16,
    'Padding-bottom--20': bottom === 20,
    'Padding-bottom--24': bottom === 24,
    'Padding-bottom--32': bottom === 32,
    'Padding-bottom--48': bottom === 48,
    'Padding-bottom--64': bottom === 64,
    'Padding-bottom--80': bottom === 80,
    'Padding-left--0': left === 0,
    'Padding-left--2': left === 2,
    'Padding-left--4': left === 4,
    'Padding-left--8': left === 8,
    'Padding-left--12': left === 12,
    'Padding-left--16': left === 16,
    'Padding-left--20': left === 20,
    'Padding-left--24': left === 24,
    'Padding-left--32': left === 32,
    'Padding-left--48': left === 48,
    'Padding-left--64': left === 64,
    'Padding-left--80': left === 80,
    'Padding-horizontal--0': horizontal === 0,
    'Padding-horizontal--2': horizontal === 2,
    'Padding-horizontal--4': horizontal === 4,
    'Padding-horizontal--8': horizontal === 8,
    'Padding-horizontal--12': horizontal === 12,
    'Padding-horizontal--16': horizontal === 16,
    'Padding-horizontal--20': horizontal === 20,
    'Padding-horizontal--24': horizontal === 24,
    'Padding-horizontal--32': horizontal === 32,
    'Padding-horizontal--48': horizontal === 48,
    'Padding-horizontal--64': horizontal === 64,
    'Padding-horizontal--80': horizontal === 80,
    'Padding-vertical--0': vertical === 0,
    'Padding-vertical--2': vertical === 2,
    'Padding-vertical--4': vertical === 4,
    'Padding-vertical--8': vertical === 8,
    'Padding-vertical--12': vertical === 12,
    'Padding-vertical--16': vertical === 16,
    'Padding-vertical--20': vertical === 20,
    'Padding-vertical--24': vertical === 24,
    'Padding-vertical--32': vertical === 32,
    'Padding-vertical--48': vertical === 48,
    'Padding-vertical--64': vertical === 64,
    'Padding-vertical--80': vertical === 80,
    'Padding-all--0': all === 0,
    'Padding-all--2': all === 2,
    'Padding-all--4': all === 4,
    'Padding-all--8': all === 8,
    'Padding-all--12': all === 12,
    'Padding-all--16': all === 16,
    'Padding-all--20': all === 20,
    'Padding-all--24': all === 24,
    'Padding-all--32': all === 32,
    'Padding-all--48': all === 48,
    'Padding-all--64': all === 64,
    'Padding-all--80': all === 80
  });
};

export default getPaddingClassNames;